import { inject } from '@angular/core';
import { CanActivateChildFn, Router } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { AuthService } from '../../../features/authentication/data-access/auth.service';
import { TokenStorageService } from '../../services/auth/token-storage.service';

/** HBW-044: where a user who must choose a new password is held. */
export const CHANGE_PASSWORD_URL = '/auth/change-password';

export const authGuard: CanActivateChildFn = (_childRoute, state) => {
  const authService = inject(AuthService);
  const tokenStorage = inject(TokenStorageService);
  const router = inject(Router);

  const loginUrlTree = router.createUrlTree(['/auth/login'], {
    queryParams: { returnUrl: state.url },
  });

  if (!authService.accessToken || !authService.currentUser) {
    authService.logout();
    return loginUrlTree;
  }

  // HBW-044: nothing opens until the user has replaced the password they were given.
  if (authService.passwordChangeRequired) {
    return router.createUrlTree([CHANGE_PASSWORD_URL]);
  }

  if (!tokenStorage.isAccessTokenExpired()) {
    return true;
  }

  if (!authService.refreshToken || tokenStorage.isRefreshTokenExpired()) {
    authService.logout();
    return loginUrlTree;
  }

  return authService.refreshAccessToken().pipe(
    map(() => true),
    catchError(() => {
      authService.logout();
      return of(loginUrlTree);
    })
  );
};
